export default function validateUrl(url) {
  // eslint-disable-next-line no-useless-escape
  const expression = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,13}(:[0-9]{1,5})?(\/.*)?$/;
  return expression.test(url);
}
